import { LeaderboardMetric } from 'fitbeat.models';

export const metricInfo = (
  leaderboardMetric: LeaderboardMetric,
): string => {
  const infoBulletPoints: { header: string, text: string }[] = [];
  if (leaderboardMetric.includes('minutes')) {
    infoBulletPoints.push({
      header: 'Score',
      text: ` - Points are earned for workout minutes.${
        leaderboardMetric.includes('weighted')
          ? '\n\n'
          : ''}`,
    });
  }
  if (leaderboardMetric.includes('points')) {
    infoBulletPoints.push({
      header: 'Score',
      text:
        ` - Points are earned for workout effort, calculated from a heart rate tracker or activities tracked in-app.${
          leaderboardMetric.includes('weighted') ? '\n\n' : ''}`,
    });
  }
  if (leaderboardMetric.includes('weighted')) {
    infoBulletPoints.push({
      header: 'Balanced Score',
      text: '- To account for teams of different sizes, '
        + 'we divide a player\'s points by the number of team members at the time of the activity.\n\n',
    });
    infoBulletPoints.push({
      header: 'Fair Scoring',
      text: ' - Teams who substantially or repetitively manipulate their player numbers '
        + 'to gain an unfair advantage will be disqualified.\n\n',
    });
    infoBulletPoints.push({
      header: 'Team Size',
      text: ' - A minimum of 3 players per team is required; '
        + 'teams of 2 players or less will earn proportionately lower points.',
    });
  }

  const metricInfoString = infoBulletPoints
    .map((item) => `${item.header}${item.text}`)
    .join('');
  return metricInfoString;
};
